import { jsx as _jsx } from "react/jsx-runtime";
import { x } from '@xstyled/styled-components';
export var Stack = function Stack(props) {
  return /*#__PURE__*/_jsx(x.div, {
    className: "flex",
    flexDirection: "column",
    children: props.children
  });
};